module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAAAXNSR0IArs4c6QAAAKZJREFUGBltkDEOwjAMRW16Fw7Q9AhdmNlBQoKNKyA4AgIViY2dqzTiNEyl5rmQCAGRHH/7fzt2xKpqZmVpFsJGvg65BrujmQ7UO9FRcEhax9gj5TQTVINXYnYS1Ro/Jm40xrVrstADOp8RLB0jjtq2YcBcowR+vNntM5eFPifEAjvSzZ+fp/lywd9lXht3cHsXqn+P9P0FvGXwXa4G0PFK54kURf0EV5FIt5rVulsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancel_red.png
// module id = 14
// module chunks = 7